import { useContext, useEffect } from "react";
import { SocketContext } from "../../../../SocketConnection";
import { useAppDispatch } from "../../../../redux-store";
import { setFocusedClient, clearFocusedClient } from ".";

/**
 * Marks a customer as "in focus": joins the customer's socket room so the UI
 * receives live delivery-address coordinate updates, and tracks the focused
 * client in redux so those updates are only applied while it stays in focus.
 * Joins/sets on mount (or when clientId changes) and leaves/clears on cleanup.
 */
export const useFocusCustomer = (clientId: string | null | undefined) => {
  const socket = useContext(SocketContext);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!socket || !clientId) {
      return;
    }
    socket.emit("join-customer-room", { clientId });
    dispatch(setFocusedClient(clientId));
    return () => {
      socket.emit("leave-customer-room", { clientId });
      dispatch(clearFocusedClient());
    };
  }, [socket, clientId, dispatch]);
};
